<template>
    <div class="sign_exam">
        <div class="sign_level">
            <h4><b>*</b>难易程度：</h4>
            <div class="sign_radio">
                <el-radio v-model="radio" label="1" >简单</el-radio>
                <el-radio v-model="radio" label="2" >一般</el-radio>
                <el-radio v-model="radio" label="3" >较难</el-radio>
                <el-radio v-model="radio" label="4" >困难</el-radio>
            </div>
        </div>    
        <div class="sign_title">
            <h4><b>*</b>题目：</h4>
            <el-input v-model="input" placeholder="请输入试题题目"></el-input>
        </div>   
        <div class="sign_answer">
            <h4 class="lf"><b>*</b>答案选项：</h4>
            <div class="clear"></div>
            <div class="sing_wrap" style="margin-left:0">
                <div class="sign_xx"  v-for="(item,index) in list_anwer" :key='index'>
                    <el-input v-model="item.name" placeholder="请输入关键词" class="lf"></el-input>
                    <img src="../../../static/img/icon_err.png" class="err_img" @click="demoList(index)">
                </div>
                <div class="clear"></div>
                <div class="add_xx" @click='add_answer()'>
                    <i class="el-icon-plus"></i><span class="add_answer">新增选项</span>
                </div>
            </div>
        </div>  
        <div class="clear"></div>
        <div class="sign_know">
            <span>知识点：</span>
            <button v-show="showbtn" @click="showKonw">
                <i class="el-icon-plus"></i><span class="add_answer">知识点</span>
            </button>
            <el-input v-model="konws" v-show="konwshow"></el-input>
        </div>
        <div class="sign_analysis">
            <span>答案解析：</span>
            <el-input
                type="textarea"
                :rows="2"
                resize='none'
                placeholder="请输入内容"
                v-model="textarea">
            </el-input>
        </div>
        <div class="btn_up">
                <el-button type="primary" @click="upExam">提交</el-button>
        </div>
    </div>
</template>
<script>
    export default{
        name:'questions',
        data () {
            return {
                radio: '1',
                imageUrl: '',
                konwshow:false,
                konws:'',
                showbtn:true,
                url:this.HOME,
                id:this.$route.query.id,
                qid:this.$route.query.q_id,
                radioSign:'',
                list_anwer:[],
                input:'',
                textarea:'',
            };
        },
         methods: {
            add_answer() {
                var code ={
                    name:''
                }
                this.list_anwer.push(code)
            },
            showKonw(){
                this.showbtn=false
                this.konwshow=true
            },
            demoList(i){
                this.list_anwer.splice(i,1)
            },
            upExam(){
                var answerList=[]
                for (var i = 0; i < this.list_anwer.length;i++) {
                    var res = this.list_anwer[i].name;
                    answerList.push(res);
                }

                if(this.id){
                    var data={
                        id:this.id,
                        level:this.radio,
                        questions:this.input,
                        type:4,
                        parsing_answer:this.textarea,
                        knowledge:this.konws,
                        service:'Question.QsnUpdate',
                        correct_answer:this.radioSign,
                        answer:JSON.stringify(answerList),
                        userid:localStorage.getItem('userid')
                    }
                }
                else{
                var data={
                    e_id:this.qid,
                    level:this.radio,
                    questions:this.input,
                    type:4,
                    parsing_answer:this.textarea,
                    knowledge:this.konws,
                    service:'Question.QsnAdd',
                    correct_answer:this.radioSign,
                    answer:JSON.stringify(answerList),
                        userid:localStorage.getItem('userid')
                    }
                }
                    this.$axios.post(this.url,this.$qs.stringify(data))
                   .then(res=>{
                        if(res.data.data.code==0){
                            this.alertView.successView('数据提交成功')
                            this.$router.push({ path:'/detail/',query: {id:this.qid}})
                        }
                        else{
                            this.alertView.failView(res.data.data.msg)
                        }
                    })
                        .catch(function (error) { // 请求失败处理
                        this.alertView.failView(res.data.data.msg)
                    });  

            }
        },
        mounted(){
            if(this.id){
                var List={
                    service:'Question.QsnEdit',
                    qid:this.id
                }
                var data =[];
                let letterArr = [];
                for (var i = 65; i < 91; i++) {
                   letterArr.push(String.fromCharCode(i))
                }
            {
               this.$axios.post(this.HOME,this.$qs.stringify(List))
                    .then(res=>{
                    this.radio = res.data.data.level;
                    this.input =res.data.data.questions;
                    for (let n in res.data.data.answer){
                        data.push({id:letterArr[n],name:res.data.data.answer[n]})
                    }
                    this.list_anwer = data
                    if(res.data.data.knowledge){
                        this.showbtn=false
                        this.konwshow=true
                        this.konws=res.data.data.knowledge
                    }
                    this.textarea=res.data.data.parsing_answer
                }) 
            }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/examView/questions.vue